import { render, staticRenderFns } from "./Kitchen.vue?vue&type=template&id=2e067a8c"
import script from "./Kitchen.vue?vue&type=script&lang=js"
export * from "./Kitchen.vue?vue&type=script&lang=js"
import style0 from "./Kitchen.vue?vue&type=style&index=0&id=2e067a8c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports